module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_chapel-43e99f4e4e48eb72cf3072554ab03cf0.webp";